import { get, post, put, patch, del } from '../http/http';
// 产品管理
export default {
  getList: (val) => get('/product', val), // 查询自己的列表
  getAllList: (val) => get('/product/all', val), // 查询所有列表
  getAllProduct: (val) => get('/product/all-product', val), // 查询所有产品
  getPermissionProductList: (val) => get('/product/permission/all', val), // 获取权限配置产品列表
  getPermissionList: (val) => get('/product/permission', val), // 获取产品权限分配分页列表
  setPermission: (val) => post('/product/permission', val), // 对账号进行产品授权
  addList: (val) => post('/product', val), // 添加
  delList: (val) => del(`/product/${val}`), // 删除
  putList: (val) => put(`/product/${val.id}`, val), // 编辑
  getInfo: (val) => get(`/product/${val}`), // 根据id查询产品详情
  getInfoList: (id, val) => get(`/product/${id}/api`, val), // 查询产品下的api
  unbind: (id, val) => put(`/product/unbind/${id}`, val), // 解绑
  release: (id, val) => patch(`/product/${id}`, val), // 上(下)架
  sortList: (val) => post('/product/order', val), // 调整产品绑定API的顺序
  getApiList: () => get('/api'), // 获取api列表
  getApigroup: () => get('/api/group'), // 获取api分组列表
  setApigroup: (id, val) => post(`/product/bind/${id}`, val), // 产品绑定Api/Api分组
  getApiMessage: (id) => get(`/product/api-doc/${id}`), // 生成Api 获取到Api分组及其绑定的api
  getApiData: (id) => get(`/product/api-doc/api/${id}`), //  api分组所绑定的api的详细数据
  getProductApiList: () => get('/api/all-api'), // 查询用户创建的所有的已上架API
  getProductApigroup: () => get('/api/group/my-group'), // 查询用户所创建的所有的已上架API分组
  getProductApiInfogroup: () => get('/api/group/my-group'), // 查询用户所创建的所有的已上架API分组 。。
  supAuditProducts: (id, val) => patch(`/product/product/${id}`, val), // 超管审核产品
  userAuditProducts: (id, val) => patch(`/product/${id}`, val), // 用户发布产品
  getRuleList: (val) => get(`/rule/product/${val}`), // 查询获取规格列表
  addRule: (val) => post('/rule', val), // 添加规格
  editRule: (val) => put(`/rule/${val.id}`, val), // 编辑规格
  delRule: (val) => del(`/rule/${val.id}/product/${val.productId}`), // 编辑规格
  createOrder: (val) => post('/order', val), // 创建订单
  getOrderQrcode: (orderNo, val) => get(`/order/${orderNo}/qr-code`, val), // 获取二维码
  getOrderStatus: (orderNo, confing) => get(`/order/${orderNo}/status`, {}, confing), // 获取订单状态
  productTypeGetList: (val) => get('/product/type/all-product-type', val), // 产品类型分页
  getAllProductType: (val) => get('/product/type/all', val), // 获取全部
  addProductType: (val) => post('/product/type', val), // 新增产品类型
  putProductType: (id,val) => put(`/product/type/${id}`, val), // 修改产品类型
  delProductType: (id) => del(`/product/type/${id}`), // 删除产品类型
  getQpsFlow: (val) => get('/api/qps/analysis', val), // 查询QPS统计
  getTotalFlow: (val) => get('/api/total/analysis', val), // 查询接口总量统计
  applicationAll: (val) => get('/application/all', val), // 查询接口总量统计
  getApi: (id) => get(`/api/applicationId/${id}`) // 查询接口总量统计
};
